import React from 'react';
import styled, { keyframes } from 'styled-components';
import { EventosHubLogo } from './EventosHubLogo';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  background: black;
  color: white;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
`;

const Logo = styled.h1`
  fontSize: 3rem;
  margin-bottom: 2rem;
  animation: ${fadeIn} 1s ease-out;
  fontWeight: 700;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  fontSize: 1.2rem;
  animation: ${fadeIn} 1s ease-out 0.5s both;
  opacity: 0.9;
`;

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = 'Cargando EventosHub...' 
}) => {
  return (
    <Container>
      <EventosHubLogo size={350} />
      <Spinner />
      <Message>{message}</Message>
    </Container>
  );
};

export default LoadingScreen;